import { apiDayToCanonicalDay } from "./studioAvailability";

const availabilityKey = (availability) =>
  `${apiDayToCanonicalDay(availability?.dayOfWeek)}|${availability?.startTime}|${availability?.endTime}`;

const canonicalStoredKey = (availability) =>
  `${availability?.dayOfWeek}|${availability?.startTime}|${availability?.endTime}`;

export const planAvailabilityReplacement = (existingAvailabilities = [], desiredAvailabilities = []) => {
  const existing = Array.isArray(existingAvailabilities)
    ? existingAvailabilities.filter((availability) => availability?.id)
    : [];
  const desired = Array.isArray(desiredAvailabilities)
    ? desiredAvailabilities
        .filter(
          (availability) =>
            availability &&
            availability.dayOfWeek !== undefined &&
            availability.startTime &&
            availability.endTime
        )
        .map((availability) => ({
          ...availability,
          dayOfWeek: apiDayToCanonicalDay(availability.dayOfWeek),
        }))
        .filter(
          (availability) =>
            Number.isInteger(availability.dayOfWeek) &&
            availability.dayOfWeek >= 1 &&
            availability.dayOfWeek <= 7
        )
    : [];

  const desiredCanonicalKeys = new Set(desired.map(availabilityKey));
  const existingCanonicalStoredKeys = new Set(
    existing
      .filter(
        (availability) =>
          Number(availability.dayOfWeek) === apiDayToCanonicalDay(availability.dayOfWeek)
      )
      .map(canonicalStoredKey)
  );

  return {
    toCreate: desired.filter(
      (availability) =>
        !existingCanonicalStoredKeys.has(
          `${apiDayToCanonicalDay(availability.dayOfWeek)}|${availability.startTime}|${availability.endTime}`
        )
    ),
    toDelete: existing.filter((availability) => {
      const canonicalDay = apiDayToCanonicalDay(availability.dayOfWeek);
      const isLegacySunday = Number(availability.dayOfWeek) !== canonicalDay;
      return isLegacySunday || !desiredCanonicalKeys.has(availabilityKey(availability));
    }),
  };
};

export const saveAvailabilityReplacement = async ({
  existingAvailabilities,
  desiredAvailabilities,
  studioId,
  createAvailability,
  deleteAvailability,
}) => {
  const { toCreate, toDelete } = planAvailabilityReplacement(
    existingAvailabilities,
    desiredAvailabilities
  );
  const createdAvailabilityIds = [];

  try {
    for (const availability of toCreate) {
      const createdAvailability = await createAvailability({
        studioID: studioId,
        dayOfWeek: availability.dayOfWeek,
        startTime: availability.startTime,
        endTime: availability.endTime,
      });

      if (createdAvailability?.id) {
        createdAvailabilityIds.push(createdAvailability.id);
      }
    }
  } catch (createError) {
    for (const createdId of createdAvailabilityIds.reverse()) {
      try {
        await deleteAvailability(createdId);
      } catch (rollbackError) {
        console.warn("Error rolling back newly created availability:", rollbackError);
      }
    }
    throw createError;
  }

  for (const availability of toDelete) {
    await deleteAvailability(availability.id);
  }

  return { created: toCreate.length, deleted: toDelete.length };
};
